import { Link, useLocation } from "react-router-dom";
import { Home, PlusCircle, Award, User } from "lucide-react";

export default function BottomNav() {
  const { pathname } = useLocation();

  const tabs = [
    { to: "/dashboard", icon: Home, label: "Home" },
    { to: "/notification", icon: PlusCircle, label: "New" },
    { to: "/dashboard?tab=electrical", icon: Award, label: "Certificates" },
    { to: "/profile", icon: User, label: "Profile" },
  ];

  const isActive = (to) => {
    if (to === "/dashboard" && pathname === "/dashboard" && !window.location.search) return true;
    if (to === "/dashboard?tab=electrical" && pathname === "/dashboard" && window.location.search.includes("tab=")) return true;
    if (to !== "/dashboard" && to !== "/dashboard?tab=electrical" && pathname.startsWith(to.split("?")[0])) return true;
    return false;
  };

  return (
    <nav
      className="fixed bottom-0 left-0 right-0 z-50 border-t backdrop-blur-md sm:hidden"
      style={{ backgroundColor: 'var(--bg-header)', borderColor: 'var(--border-main)' }}
      data-testid="bottom-nav"
    >
      <div className="flex items-center justify-around py-2 pb-[max(0.5rem,env(safe-area-inset-bottom))]">
        {tabs.map((tab) => {
          const active = isActive(tab.to);
          return (
            <Link
              key={tab.to}
              to={tab.to}
              data-testid={`bottom-nav-${tab.label.toLowerCase()}`}
              className="flex flex-col items-center gap-0.5 px-3 py-1 transition-colors"
            >
              <tab.icon
                className="w-5 h-5"
                style={{ color: active ? '#00A3E0' : 'var(--text-muted)' }}
              />
              <span
                className="text-[10px] font-semibold"
                style={{ fontFamily: 'Outfit, sans-serif', color: active ? '#00A3E0' : 'var(--text-muted)' }}
              >
                {tab.label}
              </span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
